export const USA_PLACE_ID = '7V2G7UCR3B';
